export default __webpack_public_path__ + "static/dashboard-7b4ca75bf1192d8a4ca17a12614ea716.png";